const initialState = {
  isAccountOnHold: false,
  isAccountCancelled: false,
  isAccount2FaEnabled: true,
};

const AccountStatusRedirectReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ACCOUNT_STATUS": {
      return {
        ...state,
        isAccountOnHold: action.payload === "hold",
        isAccountCancelled: action.payload === "cancelled",
      };
    }
    case "SET_ACCOUNT_2FA_STATUS": {
      return {
        ...state,
        isAccount2FaEnabled: action.payload,
      };
    }
    default:
      return state;
  }
};

export default AccountStatusRedirectReducer;
